export const _en = {
    name: {
        label: "Name"
    },
    suffix: {
        label: "Suffix"
    },
    duration: {
        label: "Duration"
    },
    refTaskStageId: {
        label: "Planification stage"
    },
    numberOfPeople: {
        label: "Number of people"
    },
    startTime: {
        label: "Start time"
    },
    withTrainee: {
        label: "In front of trainee"
    },
    trainingProductModuleId: {
        label: "Module"
    },
    refGroupId: {
        label: "Crew type"
    },
    trainingProductTaskTypeId: {
        label: "Task type"
    },
    isFFS: {
        label: "Task is FFS",
        tooltip: "A FFS's task is rule by different kind of rules"
    },
    trainingProductModuleTaskAvailabilityId: {
        label: "Availabilities time"
    },
    breakTimeBefore: {
        label: ""
    },
    breakTimeAfter: {
        label: ""
    },
    beginHour: {
        label: "Hour of Opening"
    },
    endHour: {
        label: "Hour of closing"
    },
    isToBePlanned: {
        label: "To be planned"
    },
    isOffSyllabus: {
        label: "Off syllabus"
    },
    briefing: {
        label: "Briefing duration"
    },
    debriefing: {
        label: "Debriefing duration"
    }

};

export const _fr = {
    name: {
        label: "Libellé"
    },
    suffix: {
        label: "Suffixe"
    },
    duration: {
        label: "Durée"
    },
    refTaskStageId: {
        label: "Phase de planification"
    },
    numberOfPeople: {
        label: "Nombre de stagiaires max"
    },
    refGroupId: {
        label: "Type d'équipage"
    },
    startTime: {
        label: "Heure de début"
    },
    withTrainee: {
        label: "Devant stagiaire"
    },
    trainingProductModuleId: {
        label: "Jour"
    },
    trainingProductTaskTypeId: {
        label: "Type d'activité"
    },
    isFFS: {
        label: "Est de type FFS",
        tooltip: "Une activité de type FFS est soumise à des contraintes de planification spécifiques"
    },
    trainingProductModuleTaskAvailabilityId: {
        label: "Horaires de disponibilité"
    },
    breakTimeBefore: {
        label: "Temps de pause avant l'activité"
    },
    breakTimeAfter: {
        label: "Temps de pause après l'activité"
    },
    beginHour: {
        label: "Heure d'ouverture"
    },
    endHour: {
        label: "Heure de fermeture"
    },
    isToBePlanned: {
        label: "Est à planifier",
        tooltip: "Une activité à planifier est automatiquement intégrée dans le moteur de planification"
    },
    isOffSyllabus: {
        label: "Hors syllabus",
        tooltip: "Le placement d'une activité hors syllabus est dynamique et ne tient pas compte de son positionnement au sein d'une journée de formation"
    },
    briefing: {
        label: "Durée briefing"
    },
    debriefing: {
        label: "Durée débriefing"
    }

};